<template>
  <div class='sub-content' style="display:flex"> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="product-mrp-wrap" style="width:50%">
      <dx-data-grid ref='refProductMrp'
        :data-source='mrpProductInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :focused-row-key.sync='focusedRowKeyProduct'
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparingProduct'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="productFileName"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="false"
          :allow-adding="false"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumn
          :allowEditing='false'
          caption="차종"
          data-field="차종"
          width="80"
        >
          <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          format ='#,##0'
          caption="소요량"
          dataType="number"
          data-field="소요량"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          sort-order='asc'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
            :allowEditing='false'
            caption="공정유형"
            data-field="공정유형"
            :visible='true'
          >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
              value-format='#,##0'
              show-in-column="공정유형"
              display-format="{0} (건)"
            />
          <DxTotalItem
            value-format='#,##0'
            column="합계"
            summary-type="sum"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <div class="purchase-mrp-wrap" style="width:50%">
      <dx-data-grid ref='refPurchasetMrp'
        :data-source='mrpPurchaseInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :focused-row-key.sync='focusedRowKeyPurchase'
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparingPurchase'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="purchaseFileName"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="false"
          :allow-adding="false"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumn
          :allowEditing='false'
          caption="차종"
          data-field="차종"
          width="80"
        >
          <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :min-width='54'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          format ='#,##0'
          caption="소요량"
          dataType="number"
          data-field="소요량"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          sort-order='asc'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="materialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="협력사"
          data-field="거래처코드"
          :visible='true'
        >
            <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
              value-format='#,##0'
              show-in-column="거래처코드"
              display-format="{0} (건)"
            />
          <DxTotalItem
            value-format='#,##0'
            column="합계"
            summary-type="sum"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxSummary,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import axios from 'axios'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'MonthMrp',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      // mrp product
      mrpProductInfoList: null,
      focusedRowKeyProduct: null,
      productFileName: null,
      // mrp purchase
      mrpPurchaseInfoList: null,
      focusedRowKeyPurchase: null,
      purchaseFileName: null,
      // 공통
      itemTypeLookup: null,
      processingTypeLookup: null,
      materialTypeLookup: null,
      customerLookup: null,
      carTypeLookup: null,
      thisMonth: null,
      unitLookup: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisMonth = `${AppLib.getToday().substring(0, 7)}-01`
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.customerLookup = this.$store.getters.getCompanyInfo
    this.customerLookup = this.$_.sortBy(this.customerLookup, '거래처명')
    this.carTypeLookup = this.$store.getters.getCarType
    this.refreshMrp()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    refreshMrp () {
      const product = this.$_sp.runNoEncodeFindProc('spFindAllMrpByMonth', { 계획년월: this.thisMonth, 품목유형: ConstDef.완제품 })
      const purchase = this.$_sp.runNoEncodeFindProc('spFindAllMrpByMonth', { 계획년월: this.thisMonth, 품목유형: ConstDef.구매품 })
      axios.all([product, purchase])
        .then(axios.spread((...response) => {
          this.mrpProductInfoList = this.$_sp.MakeModel(response[0])
          this.mrpPurchaseInfoList = this.$_sp.MakeModel(response[1])
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // MRP Product
    onToolbarPreparingProduct (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;margin-right:10px;'><b>자작품 소요량 </b></div>`
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>  계획월:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.thisMonth,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',

            onValueChanged: (args) => {
              this.thisMonth = args.value
              this.refreshMrp()
            }
          }
        }
      )
    },
    // MRP Purchase
    onToolbarPreparingPurchase (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:10px;'><b>구매품 소요량 </b></div>`
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '자재 소요량 업데이트',
            icon: 'decreaseindent',
            text: '전품목 소요량 재산출',
            type: 'danger',
            focusStateEnabled: false,
            onClick: (args) => {
              this.saveMrpConfirm()
            }
          }
        }
      )
    },
    saveMrpConfirm () {
      this.$snotify.confirm('소요량을 (재)산출 합니다.', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '(재)산출',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.saveMrp()
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    saveMrp () {
      this.isLoading = true
      let param = {
        title: `${this.thisMonth.substring(0, 7)}월 생산계획`,
        fromDate: this.thisMonth,
        days: null,
        품목유형: ConstDef.완제품,
        planType: 'MONTH_TOTAL'
      }
      this.isLoading = true
      HttpService.reqPostBody(this.$_sp.makeParamModel(param), '/saveMrpByPcode')
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('월계획 자재소요량을 조회하고 있습니다.', { timeout: 300 })
          this.refreshMrp()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
